var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.discussLoading,
          expression: "discussLoading"
        }
      ],
      staticClass: "discussDetail"
    },
    [
      _c("div", { staticClass: "theme_details_stem" }, [
        _c("h2", [_vm._v(_vm._s(_vm.discussDetails.theme))]),
        _vm._v(" "),
        _c("div", {
          staticClass: "editorShowArea",
          staticStyle: { "min-height": "80px" },
          domProps: { innerHTML: _vm._s(_vm.discussDetails.content) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "theme_details_stem_info" }, [
          _c("span", { staticClass: "theme_details_stem_info_left" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.discussDetails.anonymous == 1
                    ? _vm.discussDetails.userName
                    : "匿名用户"
                )
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.discussDetails.createTimeStr))])
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { display: "flex" } }, [
            _c(
              "span",
              {
                staticClass: "operation_item",
                on: {
                  click: function($event) {
                    return _vm.sameQuestion(_vm.discussDetails)
                  }
                }
              },
              [
                _c("span", { staticStyle: { "padding-right": "5px" } }, [
                  _vm._v("同问")
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.discussDetails.sameQuestionNum &&
                        _vm.discussDetails.sameQuestionNum !== "null"
                        ? _vm.discussDetails.sameQuestionNum
                        : 0
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "operation_item",
                attrs: { title: "点赞" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.replyLiked(_vm.discussDetails, "zhuti")
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "icon svg-icon",
                    staticStyle: { width: "14px", height: "14px" },
                    attrs: { "aria-hidden": "true" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-dianzan" } })]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.discussDetails.praiseCount &&
                        _vm.discussDetails.praiseCount !== "null"
                        ? _vm.discussDetails.praiseCount
                        : 0
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.discussDetails.createUser === Number(_vm.userId)
              ? _c(
                  "span",
                  {
                    staticClass: "operation_item",
                    attrs: { title: "编辑" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.getDiscussionToEdt(_vm.discussDetails)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "icon svg-icon",
                        staticStyle: { width: "14px", height: "14px" },
                        attrs: { "aria-hidden": "true" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-xiugai" } })]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.discussDetails.isCreateUser || _vm.discussDetails.isClassTeacher
              ? _c("span", {
                  staticClass: "el-icon-delete operation_item",
                  attrs: { title: "删除" },
                  on: {
                    click: function($event) {
                      return _vm.deleteDiscuss(_vm.discussDetails)
                    }
                  }
                })
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-input", {
        attrs: {
          type: "textarea",
          placeholder: "欢迎留言交流",
          minHeight: "100px",
          "show-word-limit": "",
          maxlength: "300",
          resize: "none"
        },
        model: {
          value: _vm.leavingMessage,
          callback: function($$v) {
            _vm.leavingMessage = $$v
          },
          expression: "leavingMessage"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "note-show-btn" },
        [
          _c(
            "span",
            [
              _vm._v("\n        匿名发表\n        "),
              _c("el-switch", {
                attrs: {
                  "active-color": "#1890FF",
                  "active-value": 1,
                  "inactive-value": 0
                },
                model: {
                  value: _vm.isAnonymousReply,
                  callback: function($$v) {
                    _vm.isAnonymousReply = $$v
                  },
                  expression: "isAnonymousReply"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "mini", disabled: !_vm.leavingMessage },
              on: {
                click: function($event) {
                  return _vm.publishReply()
                }
              }
            },
            [_vm._v("发表留言")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "note-goback",
              staticStyle: { "margin-top": "30px" }
            },
            [
              _vm.discussDetails.learnToolReplies
                ? _c("span", [
                    _vm._v(
                      "全部回复 " +
                        _vm._s(_vm.discussDetails.learnToolReplies.length)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span")
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.replyList, function(item, index) {
            return _c(
              "div",
              {
                key: index + "learnToolReplies",
                staticClass: "learnToolRepliesStyle"
              },
              [
                _c("p", [_vm._v(_vm._s(item.discussionContent))]),
                _vm._v(" "),
                _c("p", { staticClass: "learnToolRepliesStyleBtn" }, [
                  _c("span", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          item.anonymous === 1 ? item.userName : "匿名用户"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.replyTimeStr))])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { display: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "operation_item",
                        attrs: { title: "点赞" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.replyLiked(item, "pinglun")
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon svg-icon",
                            staticStyle: { width: "14px", height: "14px" },
                            attrs: { "aria-hidden": "true" }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-dianzan" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              item.praiseCount && item.praiseCount !== "null"
                                ? item.praiseCount
                                : 0
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "operation_item",
                        attrs: { title: "评论" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.replyComment(item)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon svg-icon",
                            staticStyle: { width: "14px", height: "14px" },
                            attrs: { "aria-hidden": "true" }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-xiaoxi" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              item.replyNum && item.replyNum !== "null"
                                ? item.replyNum
                                : 0
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    item.isCreateUser || item.teacherFlag
                      ? _c("span", {
                          staticClass: "el-icon-delete operation_item",
                          attrs: { title: "删除" },
                          on: {
                            click: function($event) {
                              return _vm.replyDelete(item)
                            }
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { class: "comment_list_wrap " + item.className }, [
                  item.deleteFlag == 0
                    ? _c(
                        "div",
                        { staticClass: "comment_area_wrap" },
                        [
                          _c("el-input", {
                            staticClass: "comment_area",
                            attrs: {
                              type: "textarea",
                              placeholder: "我来说几句",
                              maxlength: "300",
                              "show-word-limit": "",
                              resize: "none"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                return _vm.editComment(item)
                              }
                            },
                            model: {
                              value: item.commentValue,
                              callback: function($$v) {
                                _vm.$set(item, "commentValue", $$v)
                              },
                              expression: "item.commentValue"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.isShowAnonymous
                            ? _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: item.anonymousValue,
                                    callback: function($$v) {
                                      _vm.$set(item, "anonymousValue", $$v)
                                    },
                                    expression: "item.anonymousValue"
                                  }
                                },
                                [_vm._v("匿名发表")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  item.commentValue &&
                                  item.commentValue.trim() != ""
                                    ? false
                                    : true
                              },
                              on: {
                                click: function($event) {
                                  return _vm.publishComment(item)
                                }
                              }
                            },
                            [_vm._v("发表评论")]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticStyle: {
                              clear: "both",
                              "border-bottom": "1px solid #E6E6E6"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "comment_list" }, [
                    _c(
                      "ul",
                      _vm._l(item.pinglunList, function(v, i) {
                        return _c(
                          "li",
                          { key: i, staticClass: "comment_list_lis" },
                          [
                            _c("div", { staticClass: "comment_list_title" }, [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(v.discussionContent)
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "comment_list_footer" }, [
                              _c("div", { staticClass: "comment_list_left" }, [
                                _c("span", { staticClass: "comment_name" }, [
                                  _vm._v(
                                    _vm._s(
                                      v.anonymous == 1 ? v.userName : "匿名用户"
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                v.userType == 0 || v.userType == 1
                                  ? _c(
                                      "span",
                                      { staticClass: "comment_type" },
                                      [_vm._v("教师")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "comment_time" }, [
                                  _vm._v(_vm._s(v.replyTimeStr))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment_list_right" }, [
                                _c("ol", [
                                  _c(
                                    "li",
                                    {
                                      class: v.isPraise
                                        ? "comment_liked_ck"
                                        : "comment_liked",
                                      on: {
                                        click: function($event) {
                                          return _vm.likedComment(v)
                                        }
                                      }
                                    },
                                    [
                                      _c("i"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(v.praiseCount))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  v.isCreateUser || v.teacherFlag
                                    ? _c(
                                        "li",
                                        {
                                          staticClass: "comment_delete",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteComment(v, item)
                                            }
                                          }
                                        },
                                        [_c("i")]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a78e15c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a78e15c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IT/components/discussDetail.vue
// module id = null
// module chunks = 